var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2997 5.7107C17.9097 5.3207 17.2797 5.3207 16.8897 5.7107L11.9997 10.5907L7.10973 5.7007C6.71973 5.3107 6.08973 5.3107 5.69973 5.7007C5.30973 6.0907 5.30973 6.7207 5.69973 7.1107L10.5897 12.0007L5.69973 16.8907C5.30973 17.2807 5.30973 17.9107 5.69973 18.3007C6.08973 18.6907 6.71973 18.6907 7.10973 18.3007L11.9997 13.4107L16.8897 18.3007C17.2797 18.6907 17.9097 18.6907 18.2997 18.3007C18.6897 17.9107 18.6897 17.2807 18.2997 16.8907L13.4097 12.0007L18.2997 7.1107C18.6797 6.7307 18.6797 6.0907 18.2997 5.7107Z",
    fill: "#555759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.3106b4d8739285ae98c983fb44d65a8b.svg";
export { ForwardRef as ReactComponent };